<template>
  <gj-modal
      size="auto"
      :loading="loading"
      notFooterPadding
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm"
  >
    <template #header>{{batch?'批量':''}}修改运营状态</template>
    <template #content>
      <gj-operation-state-select
          width="228px"
          placeholder="运营状态"
          v-model="operationStatus"
      >
      </gj-operation-state-select>

    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn} from "@/minxins";
import {editOperationStatus} from "@/api/dashboard";

export default {
  name: "edit-status-modal",
  mixins:[modalMixIn],
  props:{
    batch:null,
    listingId:null,
    status:null
  },
  data(){
    return {
      loading:false,
      operationStatus:this.status
    }
  },
  methods:{
    confirm(){
      this.loading = true;
      editOperationStatus({operationStatus:this.operationStatus,listingIds:this.listingId}).then(data=>{
        if(data){
          this.$message.success((this.batch?'批量':'')+'修改成功')
          this.$emit('editStatus');
          this.modalVisible = false
        }
      }).complete(()=>{
        this.loading = false;
      })

    }
  }

}
</script>

<style scoped>

</style>